var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtImg',{staticClass:"align-baseline shadow",attrs:{"preload":"","provider":"storyblok","width":"18","height":"16","src":"https://a.storyblok.com/f/118728/x/22fabb8ef9/gb.svg","alt":"bendera inggris"}})
}
var staticRenderFns = []

export { render, staticRenderFns }